<template>
  <v-app id="app">
    <div>
      <v-main>
        <notifications
          group="auth"
          position="bottom center"
          class="mt-2 text-center"
        />

        <div
          v-if="$route.meta.product != 'dailyBikeRentals'"
          class="sticky-0 white"
        >
          <v-container class="py-4 ot-container">
            <div class="d-flex justify-space-between align-center">
              <div class="my-auto">
                <div class="my-auto hidden-md-and-up"></div>
                <v-img
                  @click="$router.push('/two-wheeler-rental/models')"
                  src="@/assets/logos/ontrack-logo.png"
                  height="auto"
                  width="120px"
                  contain
                  style="cursor: pointer"
                >
                </v-img>
              </div>
              <div class="text-right d-flex">
                <div
                  @click="$router.push('/two-wheeler-rental/models')"
                  class="my-auto hidden-md-and-down menuItem text--secondary"
                 
                >
                  {{ $t("Home") }}
                </div>

                <a
                  href="https://on-track.in/blogs"
                  class="my-auto hidden-md-and-down text-decoration-none menuItem text--secondary"
                >
                  {{ $t("Blogs") }}
                </a>

                <v-menu offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="menuItem my-auto text--secondary hidden-md-and-down"
                      v-bind="attrs"
                      v-on="on"
                      style="cursor: pointer"
                    >
                      {{ $t("Support") }}
                      <v-icon small>mdi-chevron-down</v-icon>
                    </div>
                  </template>

                  <v-list dense>
                    <v-list-item
                      link
                      href="https://on-track.in/faq"
                      target="_blank"
                    >
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("faqs") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      link
                      href="https://on-track.in/terms-and-conditions"
                      target="_blank"
                    >
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("terms_conditions") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      link
                      href="https://on-track.in/privacy-policy"
                      target="_blank"
                    >
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("privacy_policy") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      link
                      href="https://on-track.in/disclaimer-policy"
                      target="_blank"
                    >
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("disclaimer") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-divider class="my-2"></v-divider>

                    <v-list-item
                      link
                      href="https://api.whatsapp.com/send?phone=919148518401&text=Hi%2C%20I%20want%20to%20connect%20with%20you."
                      target="_blank"
                    >
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("Whatsapp Connect") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item link href="tel:+919148518401">
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("Call Us") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item link href="mailto:info@on-track.in">
                      <v-list-item-title class="ot-paragraph">
                        {{ $t("Email Us") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-menu offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="menuItem my-auto text--secondary hidden-md-and-down"
                      v-bind="attrs"
                      v-on="on"
                      style="cursor: pointer"
                    >
                      <v-icon size="18" color="secondary" class="mr-1">
                        mdi-translate
                      </v-icon>
                      <span class="ot-paragraph">{{ $t(locale) }}</span>
                      <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                    </div>
                  </template>

                  <v-list>
                    <v-list-item>
                      <v-radio-group
                        hide-details
                        v-model="locale"
                        class="ot-paragraph my-auto"
                      >
                        <v-radio
                          v-for="n in locales"
                          :key="n.value"
                          :label="n.text"
                          :value="n.value"
                        />
                      </v-radio-group>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn
                  href="tel:+919148518401"
                  class="menuItem my-auto hidden-md-and-down"
                  rounded
                  large
                  color="primary"
                  elevation="0"
                >
                  <div class="px-2 d-flex align-center">
                    <v-icon left>mdi-phone</v-icon>
                    <span class="ot-btn-text"> {{ $t("Call") }}</span>
                  </div>
                </v-btn>

                <v-menu offset-y open-on-hover bottom left v-if="userData">
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="ml-5 my-auto m-0 p-0 text--secondary hidden-md-and-down"
                    >
                      <v-avatar size="50" style="cursor: pointer">
                        <v-icon size="50">mdi-account-circle</v-icon>
                      </v-avatar>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item class="ot-paragraph" exact>
                      <v-list-item-title
                        >{{ $t("HI") }}, {{ userData.fName }}
                        {{ userData.lName }}</v-list-item-title
                      >
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item class="ot-paragraph" to="/account" exact>
                      <v-list-item-title>{{ $t("Profile") }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      class="ot-paragraph"
                      to="/account/bookings"
                      exact
                    >
                      <v-list-item-title>{{
                        $t("My Bookings")
                      }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      class="ot-paragraph"
                      to="/account/documents"
                      exact
                    >
                      <v-list-item-title>{{
                        $t("KYC Details")
                      }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      exact
                      class="ot-paragraph"
                      to="/account/points-and-penalties"
                    >
                      <v-list-item-title>
                        {{ $t("Points and Penalties") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item class="ot-paragraph" @click="logout" exact>
                      <v-list-item-title>{{ $t("Logout") }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn
                  v-else
                  @click="$router.push('/login')"
                  class="my-auto hidden-md-and-down ml-6"
                  large
                  outlined
                  rounded
                  color="black"
                >
                  <span class="ot-btn-text">{{ $t("Login") }}</span>
                </v-btn>

                <div class="hidden-md-and-up my-auto">
                  <v-badge
                    bordered
                    color="error accent-4"
                    dot
                    offset-x="0"
                    offset-y="10"
                    class="my-auto"
                  >
                    <div
                      class="text-caption text-uppercase link"
                      @click="sheet = !sheet"
                    >
                      <v-icon size="18" color="black">mdi-translate</v-icon>
                      <span class="ot-paragraph">{{ $t(locale) }}</span>
                    </div>
                    <v-bottom-sheet v-model="sheet">
                      <v-sheet class="" height="100%">
                        <v-card>
                          <v-container>
                            <div class="d-flex justify-space-between">
                              <h3
                                class="text-subtitle font-weight-bold my-auto"
                              >
                                Select a language
                              </h3>
                              <v-btn icon @click="sheet = !sheet">
                                <v-icon size="26">mdi-close</v-icon>
                              </v-btn>
                            </div>

                            <v-radio-group
                              v-model="locale"
                              class="ot-paragraph"
                            >
                              <v-radio
                                @click="sheet = !sheet"
                                v-for="n in locales"
                                :key="n + 'loc'"
                                :label="`${n.text}`"
                                :value="n.value"
                              ></v-radio>
                            </v-radio-group>
                          </v-container>
                        </v-card>
                      </v-sheet>
                    </v-bottom-sheet>
                  </v-badge>
                </div>

                <v-icon
                  size="30"
                  class="ml-6 hidden-md-and-up"
                  @click.stop="drawer = !drawer"
                  >mdi-menu</v-icon
                >
              </div>
            </div>
          </v-container>
          <v-divider></v-divider>
        </div>

        <router-view></router-view>
      </v-main>
    </div>

    <!-- FOOTER -->
    <FooterComponent></FooterComponent>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="">
          <!-- USER INFO / LOGIN -->
          <v-list-item v-if="userData" to="/account" class="px-2" exact>
            <v-list-item-avatar>
              <v-icon size="50">mdi-account-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <h3>{{ userData.fName }} {{ userData.lName }}</h3>
                <p class="mb-0">{{ userData.mobile }}</p>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-else two-line to="/login" exact>
            <v-list-item-content>
              <v-list-item-title
                ><h3>{{ $t("Login") }}</h3></v-list-item-title
              >
              <v-list-item-subtitle
                ><p class="mb-0">
                  {{ $t("Login to see booking, profile etc") }}
                </p></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>

          <v-divider class="mb-4"></v-divider>

          <!-- NAV LINKS -->
          <v-list-item
            to="/two-wheeler-rental/models"
            class="ot-paragraph"
            exact
          >
            {{ $t("Home") }}
          </v-list-item>

          <v-list-item exact>
            <a
              href="https://on-track.in/blogs"
              class="ot-paragraph text-decoration-none"
              target="_blank"
            >
              {{ $t("Blogs") }}
            </a>
          </v-list-item>

          <!-- How it works -->
          <v-list-item exact>
            <a
              href="https://on-track.in/how-it-works"
              class="ot-paragraph text-decoration-none"
              target="_blank"
            >
              {{ $t("How it works") }}
            </a>
          </v-list-item>

          <!-- Support Dropdown -->
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="ot-paragraph">
                  {{ $t("Support") }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item exact>
              <a
                href="https://on-track.in/faq"
                class="ot-paragraph text-decoration-none"
                target="_blank"
                >{{ $t("faqs") }}</a
              >
            </v-list-item>
            <v-list-item exact>
              <a
                href="https://on-track.in/terms-and-conditions"
                class="ot-paragraph text-decoration-none"
                target="_blank"
                >{{ $t("terms_conditions") }}</a
              >
            </v-list-item>
            <v-list-item exact>
              <a
                href="https://on-track.in/privacy-policy"
                class="ot-paragraph text-decoration-none"
                target="_blank"
                >{{ $t("privacy_policy") }}</a
              >
            </v-list-item>
            <v-list-item exact>
              <a
                href="https://on-track.in/disclaimer-policy"
                class="ot-paragraph text-decoration-none"
                target="_blank"
                >{{ $t("disclaimer") }}</a
              >
            </v-list-item>
            <v-divider class="my-2"></v-divider>
            <v-list-item exact>
              <a
                href="https://api.whatsapp.com/send?phone=919148518401&text=Hi%2C%20I%20want%20to%20connect%20with%20you."
                target="_blank"
                class="ot-paragraph text-decoration-none"
              >
                {{ $t("Whatsapp Connect") }}
              </a>
            </v-list-item>
            <v-list-item exact>
              <a
                href="tel:+919148518401"
                class="ot-paragraph text-decoration-none"
                target="_blank"
              >
                {{ $t("Call Us") }}</a
              >
            </v-list-item>
            <v-list-item exact>
              <a
                href="mailto:info@on-track.in"
                class="ot-paragraph text-decoration-none"
                target="_blank"
                >{{ $t("Email Us") }}</a
              >
            </v-list-item>
          </v-list-group>

          <v-divider class="my-2"></v-divider>
          <!-- User Links -->
          <v-list-item exact v-if="userData" to="/account" class="ot-paragraph">
            {{ $t("Profile") }}
          </v-list-item>
          <v-list-item
            exact
            v-if="userData"
            to="/account/bookings"
            class="ot-paragraph"
          >
            {{ $t("My Bookings") }}
          </v-list-item>
          <v-list-item
            exact
            v-if="userData"
            @click="logout"
            class="ot-paragraph"
          >
            {{ $t("Logout") }}
          </v-list-item>

          <!-- Call Button -->
          <v-btn
            href="tel:+919148518401"
            color="primary"
            class="white--text my-4"
            block
            rounded
            elevation="0"
          >
            <v-icon left>mdi-phone</v-icon> {{ $t("Call") }}
          </v-btn>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-dialog persistent max-width="300" v-model="languageDialog">
      <v-card>
        <v-container>
          <div class="ot-text-18 ot-text-bold">We are local!</div>
          <div class="ot-paragraph">select your preferred language</div>
          <v-radio-group v-model="locale" class="ot-paragraph">
            <v-radio
              v-for="n in locales"
              :key="n + '-lang'"
              :label="`${n.text}`"
              :value="n.value"
            ></v-radio>
          </v-radio-group>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog max-width="360" v-model="rateUsDialog">
      <v-card>
        <v-container>
          <div class="ot-text-18 ot-text-bold mb-2">Enjoying OnTrack?</div>
          <div class="ot-paragraph mb-4">
            Rate us on the app store to help others discover us!
          </div>
          <v-btn
            block
            color="primary"
            class="white--text mb-3"
            rounded
            elevation="0"
            :href="PLAY_STORE_URL"
            target="_blank"
          >
            <v-icon left>mdi-google-play</v-icon> Rate on Play Store
          </v-btn>
          <v-btn
            block
            outlined
            color="black"
            rounded
            :href="APP_STORE_URL"
            target="_blank"
          >
            <v-icon left>mdi-apple</v-icon> Rate on App Store
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- 🧪 TEST FLOATING BUTTON
    <v-btn
      @click="testPurchaseEvent"
      fab
      fixed
      bottom
      right
      color="warning"
      style="z-index: 9999; margin-bottom: 80px;"
    >
      🧪
    </v-btn> -->
  </v-app>
</template>

<script>
import { logFirebaseEvent } from "@/services/firebase.js";
import FooterComponent from "./components/footerComponent.vue";
import { trackUTM } from "@/utils/trafficAttribution";

export default {
  name: "App",

  metaInfo() {
    return {
      meta: [
        {
          vmid: "robots",
          name: "robots",
          content: this.$route.meta.noindex
            ? "noindex, nofollow"
            : "index, follow",
        },
      ],
    };
  },

  components: { FooterComponent },

  data: () => ({
    notices: [],
    fab: false,
    drawer: false,
    group: "",
    sheet: false,
    languageDialog: false,
    rateUsDialog: false,
    PLAY_STORE_URL:
      "https://play.google.com/store/apps/details?id=com.ontrack.ontrack&hl=en",
    APP_STORE_URL:
      "https://apps.apple.com/in/app/ontrack-monthly-bike-rental/id1433908606",
    locale: "",
    locales: [
      { text: "English", value: "en" },
      { text: "हिन्दी", value: "hi" },
      { text: "Kannada", value: "ka" },
    ],

    //
  }),
  updated() {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  },
  async mounted() {
    setTimeout(() => {
      trackUTM(); // let GA4 cookies load before creating session for better attribution, especially for paid campaigns
    }, 500);

    // NOTE: gtag.js automatically captures utm_source, utm_medium, utm_campaign, and gclid
    // The code below is kept for backward compatibility with any legacy code that references localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const source =
      urlParams.get("utm_source") || urlParams.get("source") || "direct";
    const medium =
      urlParams.get("utm_medium") || urlParams.get("medium") || "website";
    const campaign =
      urlParams.get("utm_campaign") ||
      urlParams.get("campaign") ||
      urlParams.get("campaignid") ||
      "direct";

    localStorage.setItem("trafficSource", source);
    localStorage.setItem("trafficSourceCampaign", campaign);
    localStorage.setItem("trafficSourceMedium", medium);
    // Click IDs, captured alongside UTMs so later API calls (e.g. OTP send/
    // verify) can infer source/campaign for ad clicks that arrive without an
    // explicit utm_source/utm_campaign on the creative.
    localStorage.setItem("trafficGclid", urlParams.get("gclid") || "");
    localStorage.setItem("trafficFbclid", urlParams.get("fbclid") || "");
    localStorage.setItem("trafficWbraid", urlParams.get("wbraid") || "");

    // ?rate_us=1 sends mobile users straight to their platform's store listing;
    // desktop visitors get a dialog with both store links since there's no
    // native app store to redirect to.
    const isRateUsFlow = urlParams.get("rate_us") === "1";
    if (isRateUsFlow) {
      const ua = navigator.userAgent || navigator.vendor || "";
      if (/android/i.test(ua)) {
        window.location.href = this.PLAY_STORE_URL;
      } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
        window.location.href = this.APP_STORE_URL;
      } else {
        this.rateUsDialog = true;
      }
    }

    await this.$recaptchaLoaded();
    setTimeout(() => {
      let language = localStorage.getItem("language");
      const currentPath = this.$route.fullPath;

      if (!language && !currentPath.includes("two-wheeler-loan") && !isRateUsFlow) {
        this.languageDialog = true;
      } else {
        this.locale = language ? language : "en";
        this.$i18n.locale = language ? language : "en";
      }
    }, 1200);
  },
  watch: {
    locale() {
      this.changeLocale();
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("AUTH_LOGOUT").then(() => {
        this.$router.push("/");
      });
    },
    redirect(url) {
      window.location.href = url;
    },

    // testPurchaseEvent() {
    // console.log("🧪 Testing purchase event with mock data...");

    // if (typeof gtag === "undefined") {
    //   console.error("❌ gtag not loaded!");
    //   alert("gtag not loaded - check public/index.html");
    //   return;
    // }

    // // Mock data
    // const mockBookingId = "TEST_" + Date.now();
    // const mockPrice = 3500;
    // const mockModel = {
    //   id: 999,
    //   name: "Honda Activa 5G (TEST)",
    // };

    // // Fire the purchase event
    // // eslint-disable-next-line no-undef
    // gtag("event", "purchase", {
    //   transaction_id: String(mockBookingId),
    //   value: Number(mockPrice),
    //   currency: "INR",
    //   tax: 0,
    //   shipping: 0,
    //   items: [
    //     {
    //       item_id: String(mockModel.id),
    //       item_name: mockModel.name,
    //       item_category: "MONTHLY",
    //       item_category2: "Website",
    //       price: Number(mockPrice),
    //       quantity: 1,
    //     },
    //   ],
    // });

    // console.log("✅ Purchase event sent:", {
    //   transaction_id: mockBookingId,
    //   value: mockPrice,
    //   currency: "INR",
    // });

    // alert(`Purchase event sent!\n\nCheck:\n1. Browser console\n2. Network tab (filter: collect)\n3. GA4 DebugView (if enabled)`);
    // },

    changeLocale() {
      localStorage.setItem("language", this.locale);
      this.$i18n.locale = this.locale;
      this.languageDialog = false;
      logFirebaseEvent("language-" + this.locale, {
        event_category: "click-event",
        event_label: "Language Toggle",
        value: 1,
      });
      // window.location.reload();
    },
  },
  computed: {
    isTwoWheelerRoute() {
      return this.$route.path.includes("two-wheeler-rental");
    },
    userData() {
      return this.$store.getters.getLoggedInUser;
    },
  },
};
</script>

<style>
:root {
  --default-font: system-ui, -apple-system, "Segoe UI", "Helvetica Neue",
    "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

body {
  font-family: var(--default-font);
}

.footer-text a {
  text-decoration: none;
  color: white !important;
  display: block;
  padding-bottom: 10px;
}
.footer-text a:hover {
  text-decoration: underline;
}
@media only screen and (max-width: 600px) {
  .scroll-container {
    display: flex;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap !important;
    overflow: scroll !important;
  }
  .md-max-500 {
    max-width: 100% !important;
  }
}

.v-btn,
.v-tab {
  text-decoration: none !important;
  text-transform: capitalize !important;
  letter-spacing: normal !important;
}

.sticky-0 {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  font-size: 20px;
  z-index: 3;
}

.menuItem {
  font-size: 16px;
  padding: 16px !important;
  text-transform: none;
  font-weight: 700;
}

.menuItem:hover {
  cursor: pointer;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
